// extracted by mini-css-extract-plugin
export var acitonButtons = "_ib-0";
export var additionalIcon = "_ib-f";
export var block = "_ib-1";
export var blockContent = "_ib-7";
export var blockDescription = "_ib-8";
export var blockIcon = "_ib-9";
export var blockTitle = "_ib-6";
export var border = "_ib-a";
export var center = "_ib-l";
export var edge = "_ib-b";
export var edgeLabel = "_ib-c";
export var edgePath = "_ib-d";
export var error = "_ib-e";
export var flowchart = "_ib-g";
export var flowchartContent = "_ib-h";
export var highlighted = "_ib-3";
export var hover = "_ib-4";
export var icon = "_ib-i";
export var left = "_ib-m";
export var navButton = "_ib-j";
export var navButtons = "_ib-k";
export var right = "_ib-n";
export var selected = "_ib-2";
export var small = "_ib-5";